const franchiseEndpoint =
    '/site/api/franchise' +
    '?include=teams.id' +
    '&include=teams.active' +
    '&include=teams.triCode' +
    '&include=teams.placeName' +
    '&include=teams.commonName' +
    '&include=teams.fullName' +
    '&include=teams.logos' +
    '&include=teams.conference.name' +
    '&include=teams.division.name' +
    '&include=teams.franchiseTeam.firstYear' +
    '&include=teams.franchiseTeam.firstSeason.id' +
    '&include=teams.franchiseTeam.lastSeason.id' + // TODO: Remove after merge with standings is done, update Franchise.jsx? Double check this
    '&sort=[{"property":"teamPlaceName"},{"property":"teamCommonName"}]';

const franchiseSeasonResultsEndpoint = (id) =>
    '/site/api/franchise-season-results' +
    `?cayenneExp=franchiseId=${id}` +
    '&include=["season.conferencesInUse", "season.divisionsInUse"]' +
    '&sort=seasonId' +
    '&dir=DESC';

const rosterByTeamEndpoint = (id) =>
    `/site/api/player/byTeam/${id}` +
    '?include=id' +
    '&include=firstName' +
    '&include=lastName' +
    '&include=sweaterNumber' +
    '&include=position' +
    '&include=height' +
    '&include=weight' +
    '&include=birthDate' +
    '&include=birthCountry' +
    '&include=birthCity' +
    '&include=birthStateProvince' +
    '&include=onRoster';

const franchiseDetailsEndpoint = '/site/api/franchise-detail';
const franchiseHistoryEndpoint = (id) => `/site/api/franchise-detail?cayenneExp=mostRecentTeamId=${id}`;
const allTimeRecordVsFranchiseEndpoint = (id) =>
    `/site/api/all-time-record-vs-franchise?cayenneExp=teamFranchiseId=${id}`;
const playoffFranchiseVsTeamEndpoint = (id) => `/site/api/playoff-franchise-vs-team?cayenneExp=teamFranchiseId=${id}`;

export default {
    franchiseEndpoint,
    franchiseSeasonResultsEndpoint,
    rosterByTeamEndpoint,
    franchiseDetailsEndpoint,
    franchiseHistoryEndpoint,
    allTimeRecordVsFranchiseEndpoint,
    playoffFranchiseVsTeamEndpoint,
};
